<template>
  <div id="app">
    <component :is="layout"></component>
    <!-- 图形验证码传该dom id -->
    <p id="capcha_dom_id" style="display: none"></p>
    <template v-if="showIntercept">
      <Intercept />
    </template>
  </div>
</template>

<script>
import Noop from '@/layouts/Noop'
import Dashboard from '@/layouts/Dashboard'
import PrepareDetail from '@/layouts/PrepareDetail'
import Intercept from './layouts/Intercept.vue'
import { mapState } from 'vuex'
import { getElementSelector } from '@/utils/whatsElement'

export default {
  name: 'app',
  components: { Intercept },
  data: () => ({
    interceptUnitId: []
  }),
  computed: {
    ...mapState({
      unitId: (state) => state.user && state.user.unit_id
    }),
    layout() {
      switch (this.$route.meta.layout) {
        case 'dashboard':
          return Dashboard
        case 'prepareDetail':
          return PrepareDetail
        default:
          return Noop
      }
    },
    showIntercept() {
      const { unitId, interceptUnitId } = this
      // 判断当前的unit_id是否包含在要拦截的机构列表中
      return interceptUnitId.includes(unitId)
    }
  },
  methods: {
    reportElementClick(e) {
      const selector = getElementSelector(e.target)
      this.$store.dispatch('reportPageClick', selector)
      this.$store.dispatch('reportElementClick', selector)
    },
    // 从七牛云获取要拦截的机构列表id
    async getEduorganizationIds() {
      const res = await fetch(
        `https://source-static.codemao.cn/teacher-edu/organization_ids.json?CMTIME=${Date.now()}`
      ).then((res) => res.json())
      this.interceptUnitId = res
    }
  },
  mounted() {
    document.addEventListener('click', this.reportElementClick, true)
    this.getEduorganizationIds()
  },
  beforeDestroy() {
    window.removeEventListener('click', this.reportElementClick)
  }
}
</script>
<style lang="scss" src="@/assets/styles/index.scss"></style>
